import { type SearchEntry } from '@ctn/ui/types/ctn-filter-bar';
import { yupResolver } from '@hookform/resolvers/yup';
import { type Resolver } from 'react-hook-form';
import * as yup from 'yup';

import { PAGE_SIZE } from '@/constants/table.constants';

export const PAYLOAD_PAGINATION = {
	start: 0,
	limit: PAGE_SIZE.DEFAULT,
};

export const searchFields = [
	{ label: 'Titular inscrito', value: 'titular' },
	{ label: 'Nº documento', value: 'nDocumento' },
	{ label: 'Título o causa', value: 'titulo' },
	{ label: 'Dirección', value: 'domicilio' }
];

export const payloadDefault = () => ({
	...PAYLOAD_PAGINATION,
});

export type FilterFormData = {
	fecha: string[];
	search?: SearchEntry[];
};
    
export const getSchema = (): Resolver<FilterFormData> => {
	const schema = yup.object().shape({
		fecha: yup.array(),
	});
	return yupResolver(schema) as Resolver<FilterFormData>;
};
    
export const defaultValues = () => ({
	fecha: [],
	search: [],
});